
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCameraTilt as ObiCameraTiltElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-camera-tilt.js';
 
 
 

 
 export const ObiCameraTilt = createComponent({
   react: React,
   tagName: 'obi-camera-tilt',
   elementClass: ObiCameraTiltElement,
   events: {
     
   }
  });
 
 